import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);
    
    if (result.success) {
      toast.success('Welcome back!');
      navigate('/');
    } else {
      toast.error(result.error || 'Login failed');
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#18261E] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <Link to="/" className="brand-logo text-4xl inline-block" data-testid="brand-logo">habitué</Link>
          <h2 className="text-3xl tracking-tight text-[#E8EBE9] mt-8 mb-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Welcome back</h2>
          <p className="text-[#889990]">Sign in to your account</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
          <div>
            <label className="block text-xs tracking-[0.2em] uppercase text-[#C3A365] font-semibold mb-3">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-[#283D32] border border-[#3E5248] px-4 py-4 text-base text-[#E8EBE9] placeholder:text-[#889990] focus:border-[#145A3A] focus:ring-0 outline-none transition-all"
              placeholder="you@example.com"
              data-testid="login-email-input"
            />
          </div>

          <div>
            <label className="block text-xs tracking-[0.2em] uppercase text-[#C3A365] font-semibold mb-3">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-[#283D32] border border-[#3E5248] px-4 py-4 text-base text-[#E8EBE9] placeholder:text-[#889990] focus:border-[#145A3A] focus:ring-0 outline-none transition-all"
              placeholder="••••••••"
              data-testid="login-password-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#C3A365] text-[#18261E] hover:shadow-[0_8px_32px_rgba(195,163,101,0.4)] px-8 py-4 font-semibold tracking-wide text-sm transition-all disabled:opacity-50"
            data-testid="login-submit-button"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="mt-8 text-center">
          <p className="text-[#889990]">
            Don't have an account?{' '}
            <Link to="/register" className="text-[#C3A365] hover:text-[#D4B876] font-medium transition-colors" data-testid="register-link">
              Create one
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
